import { useMutation } from "@tanstack/react-query";
import { postChatChannelChannelIdReject } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRejectChatChannelMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation<void, unknown, string>({
    mutationFn: processResponseWithApiProblemDetails((channelId: string) =>
      postChatChannelChannelIdReject(channelId),
    ),
    onSuccess,
    onError,
  });
